import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import router from './router'
import {store, useGlobalStore} from '@/pinia'
import '@/assets/icon/iconfont.css'
import moment from 'moment'
import axios from 'axios'
import {getDomainChannel} from "@/api/home"; // 引入axios

moment.locale('zh-cn')

Vue.config.productionTip = false

async function bootstrap() {
    const globalStore = useGlobalStore()

    let res = await getDomainChannel({domain: window.location.hostname})
    if (res.code === 0) {
        globalStore.promotion.ChannelID = parseInt(res.data.chanel)
        globalStore.site = parseInt(res.data.site)
    }
    new Vue({
        store,
        router,
        render: h => h(App)
    }).$mount('#app')
}

bootstrap()

